import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import { useMutation, useQuery } from 'data-fetching-client';
import getIn from 'immutable-less/transmute/getIn';
import { GENERATE_DESCRIPTION, GENERATE_DESCRIPTION_FIELD_NAME } from 'automation-ui-management/queries/flowQueries';
import { useEffect } from 'react';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { GET_AI_SETTINGS_ACCESS } from 'automation-ui-management/queries/aiSettingsQueries';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AiDescriptionSuggestion = ({
  onEdit,
  flowId,
  fallbackElement,
  setAiFlowDescription,
  aiFlowDescription
}) => {
  var _data$aiSettingsAcces, _data$aiSettingsAcces2;
  const {
    data
  } = useQuery(GET_AI_SETTINGS_ACCESS);
  const isContentAssistanceEnabled = (_data$aiSettingsAcces = data === null || data === void 0 || (_data$aiSettingsAcces2 = data.aiSettingsAccess) === null || _data$aiSettingsAcces2 === void 0 ? void 0 : _data$aiSettingsAcces2.crmPropertiesEnabled) !== null && _data$aiSettingsAcces !== void 0 ? _data$aiSettingsAcces : false;
  const trackEvent = useTrackEvent();
  const [generateDescription, generateDescriptionResult] = useMutation(GENERATE_DESCRIPTION, {
    onError: error => {
      reportError({
        error
      });
    }
  });
  const getGeneratedDescription = _data => aiFlowDescription || getIn([GENERATE_DESCRIPTION_FIELD_NAME, 'description'], _data);
  useEffect(() => {
    if (aiFlowDescription) {
      return;
    }
    generateDescription({
      variables: {
        flowId
      }
    }).then(res => {
      setAiFlowDescription(getGeneratedDescription(res.data) || '');
      trackEvent(Trackables.GENERATE_DESCRIPTION_WORKFLOW_NAME_AND_DESCRIPTION_MODAL);
    }).catch(error => {
      reportError({
        error
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const generatedDescription = getGeneratedDescription(generateDescriptionResult.data);
  const buttonWrapper = !generateDescriptionResult.loading && /*#__PURE__*/_jsx(UIButtonWrapper, {
    className: "m-top-2",
    justify: "between",
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(UIButton, {
        onClick: () => {
          if (onEdit) {
            onEdit(generatedDescription || '');
          }
        },
        use: "tertiary-light",
        size: "extra-small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-management.WorkflowNameWithDescription.descriptionAndNameSuggestion.edit"
        })
      })
    })
  });
  if (generateDescriptionResult.error || !isContentAssistanceEnabled) {
    return fallbackElement !== null && fallbackElement !== void 0 ? fallbackElement : null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        position: 'relative',
        width: '100%'
      },
      children: /*#__PURE__*/_jsx("div", {
        style: {
          position: 'absolute',
          top: -28,
          right: 0
        },
        children: /*#__PURE__*/_jsx(AIBadge, {})
      })
    }), /*#__PURE__*/_jsx(View, {
      as: "div",
      borderStyle: "solid",
      borderColor: "fill-accent-magenta-subtle",
      borderRadius: "200",
      borderWidth: "100",
      backgroundColor: "fill-accent-magenta-subtle",
      padding: "300",
      children: generateDescriptionResult.loading ? /*#__PURE__*/_jsx(UILoadingSpinner, {
        className: "m-x-0",
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-management.WorkflowNameWithDescription.descriptionAndNameSuggestion.loading"
        }),
        showLabel: true
      }) : generatedDescription
    }), buttonWrapper]
  });
};
export default AiDescriptionSuggestion;